<div>
    <div>
        <table mat-table [dataSource]="messageDataSource">
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; let column; let i = index">
              <button mat-icon-button (click)="deleteMessage(row, i)">
                <mat-icon>delete_outline</mat-icon>
              </button>
              <button mat-icon-button (click)="openLinkMessage(row)">
                <mat-icon>link</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>From</th>
            <td mat-cell *matCellDef="let element">
              {{ element.from?.emailAddress?.address }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sendTo">
            <th mat-header-cell *matHeaderCellDef>To</th>
            <td mat-cell *matCellDef="let element">
              {{ element.toRecipients[0]?.emailAddress.address }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Received Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.receivedDateTime | date: 'dd/MM/yyyy, H:mm' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef>Subject</th>
            <td mat-cell *matCellDef="let element">
              {{ element.subject }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedMessageColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedMessageColumns"></tr>
        </table>

        <mat-paginator #paginator (page)="pageChangeEvent($event)"
        [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" showFirstLastButtons [length]="resultsLength">
      </mat-paginator>
    </div>
</div>
